import { cn } from '@repo/ui/lib/utils';
import SectionChild from './SectionChild';
import { Img } from "openimg/react";
function LinearGradient() {
  return (
    <div
      className="absolute bottom-0 w-full h-full rounded-md group-hover:cursor-pointer bg-grad-hero"
    ></div>
  );
}



function Hero({
  image = "/image/landing_page/Banner_1.png",
  title,
  showLinear,
  className,
}: {
  image?: string;
  title?: string;
  showLinear?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "w-full h-[375px] md:h-[450px]  relative overflow-hidden",
        className
      )}
    >
      <Img
        className="absolute top-0 left-0 object-cover w-full h-full"
        src={image}
        fit="cover"
        width={1440}
        height={450}
        params={{
          "black-white": "true",
          blur: "5",
          quality: "100",
        }}
      />
      {showLinear && <LinearGradient />}
      {title && (
        <div className="absolute w-full bottom-14">
          <SectionChild>
            <h1 className="text-4xl font-bold text-white md:text-6xl font-helve">
              {title}
            </h1>
          </SectionChild>
        </div>
      )}
    </div>
  );
}

export default Hero
